import axios from "axios";

export const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE_URL}/api`;

export const api = axios.create({ baseURL: API });

export function authHeaders() {
    const t = localStorage.getItem("jw_admin_token");
    return t ? { Authorization: `Bearer ${t}` } : {};
}

export function getToken() {
    return localStorage.getItem("jw_admin_token");
}
